import React, { useEffect, useState } from 'react';
import { BiCalendar } from 'react-icons/bi';
import BlockHeader from '../BlockHeader/BlockHeader';
import CalendarSelect from '../CalendarSelect/CalendarSelect';
import { calendarSelectTypes } from '../../constants';
import { getCalendarSelectItems } from '../../utils';
import styles from './CalendarHeader.module.scss';

const CalendarHeader = ({ selectedDate, onDateChange, validRange }) => {
  const [yearList, setYearList] = useState([]);
  const [monthList, setMonthList] = useState([]);

  useEffect(() => {
    const yearList = getCalendarSelectItems.year(validRange);
    setYearList(yearList);
  }, [validRange]);

  useEffect(() => {
    const monthList = getCalendarSelectItems.month(validRange, selectedDate);
    setMonthList(monthList);
  }, [validRange, selectedDate.year()]);

  return (
    <header className={styles.root}>
      <BlockHeader
        icon={<BiCalendar />}
        title="Выбрать дату"
        description={selectedDate.format('dddd, D MMMM YYYY')}
      />
      <div className={styles.actions}>
        <CalendarSelect
          type={calendarSelectTypes.month}
          items={monthList}
          currentDate={selectedDate}
          onDateChange={onDateChange}
        />
        <CalendarSelect
          type={calendarSelectTypes.year}
          items={yearList}
          currentDate={selectedDate}
          onDateChange={onDateChange}
        />
      </div>
    </header>
  );
};

export default CalendarHeader;
